import React, { useState, Dispatch, useEffect } from 'react';
import { Container, SecRowLine, SecLabelRow, SecSpanBlock, Titulo } from './style';
import { Modal, Button, Collapse, Skeleton } from 'antd';
import {
  UserOutlined,
  CopyOutlined,
  MessageOutlined,
  CalendarOutlined,
  BorderlessTableOutlined,
  EnvironmentOutlined,
  ShopOutlined,
  AlertOutlined,
} from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { loadRequest as loadOcorrenciaRequest } from '../../../../store/ducks/ocorrencia/actions';
import { loadRequest } from '../../../../store/ducks/atendimentos/actions';
import { loadMessageReadRequest } from '../../../../store/ducks/notifications/actions';
import Reabrir from '../../Modal/Reabrir';
import { Props } from './types';
import { colorIconConversation } from '../../Utils';
import { maskCapitalized } from '../../../../utils/mask';
import GetStatus from '../../../../components/GetStatus';
import GetSeveridade from '../../components/GetSeveridade';
import moment from 'moment';
import FormMessage from '../../Modal/Conversation/LeftContainer/Form';
import BoxMessage from '../../Modal/Conversation/LeftContainer/BoxMessage';
import { ROLE } from '../../../../utils/roles';

const CardSecMobile: React.FC<Props> = ({ props }) => {
  const { Panel } = Collapse;
  const dispatch = useDispatch<Dispatch<Action>>();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const ocorrencia = useSelector((state: ApplicationState) => state.Ocorrencia.data['ocorrencia']);
  const loading = useSelector((state: ApplicationState) => state.Ocorrencia.loading);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const color = colorIconConversation(props?.urgencia);
  const paginations = useSelector((state: ApplicationState) => state.Atendimentos?.pagination);
  const filter = useSelector((state: ApplicationState) => state.Atendimentos?.filter);

  useEffect(() => {
    dispatch(loadMessageReadRequest(props.protocolo));
  }, [props, dispatch]);

  const showModal = () => {
    dispatch(loadOcorrenciaRequest(props.protocolo));
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    // dispatch(loadRequest(filter, cddAtivo.codCdd, inscricaoAtiva, paginations));
    setIsModalVisible(false);
  };

  function formatCyte(cidade: string) {
    const city = cidade?.split(' - ');
    return maskCapitalized(city[0]) + ' - ' + city[1]?.toUpperCase();
  }

  return (
    <Container>
      <Button type="primary" onClick={showModal} className="buttonModalConversacao">
        Ver atendimento
      </Button>

      <Modal
        title={
          !loading && (
            <>
              <span style={{ color: color }}>#</span>
              <span className="themeSLA">
                {ocorrencia?.protocolo} - {ocorrencia?.tipoSolicitacao}
              </span>
            </>
          )
        }
        visible={isModalVisible}
        footer={null}
        onCancel={handleCancel}
      >
        {!loading ? (
          <div>
            <SecRowLine>
              <SecLabelRow className="themeSLA">
                <BorderlessTableOutlined style={{ color: color }} /> Status
              </SecLabelRow>
              {ocorrencia?.status ? <GetStatus acronym={ocorrencia.status} /> : 'Não informado'}
            </SecRowLine>

            <SecRowLine>
              <SecLabelRow className="themeSLA">
                <AlertOutlined style={{ color: color }} /> Urgência
              </SecLabelRow>
              {ocorrencia?.urgencia ? (
                <GetSeveridade severity={ocorrencia.urgencia} />
              ) : (
                'Não informado'
              )}
            </SecRowLine>

            <Collapse
              defaultActiveKey={[]}
              style={{ border: 'none' }}
              className="themeColorMobileContainer"
            >
              <Panel header={<Titulo>Detalhes do atendimento</Titulo>} key="1">
                <SecRowLine>
                  <SecLabelRow className="themeSLA">
                    <ShopOutlined style={{ color: color }} /> Centro de distribuição
                  </SecLabelRow>{' '}
                  <SecSpanBlock className="themeSLA">
                    {ocorrencia?.centrodistribuicao
                      ? maskCapitalized(ocorrencia.centrodistribuicao)
                      : 'Não informado'}
                  </SecSpanBlock>
                </SecRowLine>

                <SecRowLine>
                  <SecLabelRow className="themeSLA">
                    <UserOutlined style={{ color: color }} /> Parceiro
                  </SecLabelRow>
                  <SecSpanBlock className="themeSLA">
                    {ocorrencia?.parceiro ? maskCapitalized(ocorrencia?.parceiro) : 'Não informado'}
                  </SecSpanBlock>
                </SecRowLine>

                <SecRowLine>
                  <SecLabelRow className="themeSLA">
                    <UserOutlined style={{ color: color }} /> Embarcador
                  </SecLabelRow>
                  <SecSpanBlock className="themeSLA">
                    {ocorrencia?.embarcador
                      ? maskCapitalized(ocorrencia.embarcador)
                      : 'Não informado'}
                  </SecSpanBlock>
                </SecRowLine>

                <SecRowLine>
                  <SecLabelRow className="themeSLA">
                    <UserOutlined style={{ color: color }} /> Atendente
                  </SecLabelRow>
                  <SecSpanBlock className="themeSLA">
                    {ocorrencia?.atendente ? ocorrencia.atendente : 'Não informado'}
                  </SecSpanBlock>
                </SecRowLine>

                <SecRowLine>
                  <SecLabelRow className="themeSLA">
                    <CopyOutlined style={{ color: color }} /> Nota(s)
                  </SecLabelRow>
                  <SecSpanBlock className="themeSLA">
                    {ocorrencia?.listaNf ? ocorrencia.listaNf : 'Não informado'}
                  </SecSpanBlock>
                </SecRowLine>

                <SecRowLine>
                  <SecLabelRow className="themeSLA">
                    <EnvironmentOutlined style={{ color: color }} /> Destino
                  </SecLabelRow>
                  <SecSpanBlock className="themeSLA">
                    {ocorrencia?.cidade ? formatCyte(ocorrencia.cidade) : 'Não informado'}
                  </SecSpanBlock>
                </SecRowLine>

                <SecRowLine>
                  <SecLabelRow className="themeSLA">
                    <CalendarOutlined style={{ color: color }} /> Data da abertura
                  </SecLabelRow>
                  <SecSpanBlock className="themeSLA">
                    {ocorrencia?.dhAbertura
                      ? moment(ocorrencia.dhAbertura).format('lll')
                      : 'Não informado'}
                  </SecSpanBlock>
                </SecRowLine>
                <SecRowLine>
                  <SecLabelRow className="themeSLA">
                    <CalendarOutlined style={{ color: color }} /> Data da conclusão
                  </SecLabelRow>
                  <SecSpanBlock className="themeSLA">
                    {ocorrencia?.dhConclusao
                      ? moment(ocorrencia.dhConclusao).format('lll')
                      : 'Em aberto'}
                  </SecSpanBlock>
                </SecRowLine>
                <SecRowLine>
                  <SecLabelRow className="themeSLA">
                    <MessageOutlined style={{ color: color }} /> Assunto
                  </SecLabelRow>
                  <SecSpanBlock className="themeSLA">
                    {ocorrencia?.assunto ? ocorrencia.assunto : 'Não informado'}
                  </SecSpanBlock>
                </SecRowLine>

                <SecRowLine>
                  {perfil !== ROLE.ADMINISTRADOR && perfil !== ROLE.ANALISTACD && (
                    <Reabrir propriedades={ocorrencia} />
                  )}
                </SecRowLine>
              </Panel>
            </Collapse>
          </div>
        ) : (
          <Skeleton active />
        )}
        <div style={{ margin: '10px 0' }}>
          <BoxMessage protocolo={ocorrencia?.protocolo} />
        </div>
        <FormMessage protocolo={ocorrencia?.protocolo} status={ocorrencia?.status} />
      </Modal>
    </Container>
  );
};

export default CardSecMobile;
